export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";